<template>
  <div class="main-content">
    <div>
      <!--      TOPBAR FILTROS-->
      <v-card class="pl-3 pr-3" style="height: 62px; background-color: #F0F0F0" outlined shaped tile>
        <v-row>
          <v-col md="2">
            <v-select
              v-model="filtroUsuarios"
              :items="opcoesFiltro"
              spellcheck="false"
              placeholder=" "
              style="border-top-left-radius: 15px;"
              height="32px"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col>
            <v-btn class="ml-n4" color="#2A2F50" @click="abrirDialogIncluirUsuario()" height="32px" style="margin-top: 2px" dark small>
              <v-icon class="mr-1">
                mdi-account
              </v-icon>
              Incluir Usuário
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <!--      GRID USUARIOS-->
      <v-card style="border-top-right-radius: 20px;" class="mt-2" outlined tile>
        <perfect-scrollbar style="max-height: 635px">
          <v-data-table
            :loading="loading"
            loading-text="Carregando, aguarde..."
            :headers="headers"
            :items="usuarios.data"
            :items-per-page="limit"
            :sort-desc="sortDesc"
            hide-default-footer
            hide-action
            sort-by="id"
            item-key="id"
          >
            <template v-slot:body="{ items }">
              <tr id="fs-row" v-for="item in items" :key="item.id">
                <td>{{ item.id }}</td>
<!--                <td>-->
<!--                  <v-img v-if="item.pessoa" :src="item.pessoa.foto_url" class="fs-miniatura"></v-img>-->
<!--                  <v-img v-else :src="require('@/assets/semfoto.png')" class="fs-miniatura"></v-img>-->
<!--                </td>-->
                <td>{{ item.nome }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.acessoGrupo.descricao }}</td>
                <td>{{ item.ativo === 'S' ? 'Sim' : 'Não' }}</td>
                <td>{{ formatarDataHora(item.created_at, 'L') }}</td>
                <td width="100px">
                  <v-btn @click="abrirDialogEditarUsuario(item)" icon>
                    <v-icon>mdi-pen</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </perfect-scrollbar>

        <!--        FOOTER-->
        <v-row class="ml-4 mr-6 my-3" no-gutters>
          <v-col cols="12">
            <v-row align="center" justify="space-between">
              <v-card class="ml-3" flat>
                <v-btn-toggle
                  v-model="limit"
                  mandatory
                  group
                  dense
                >
                  <v-btn :value="15" class="fs-btn-limit">15</v-btn>
                  <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                  <v-btn :value="25" class="fs-btn-limit">25</v-btn>
                  <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                  <v-btn :value="999999999" class="fs-btn-limit">Listar Todos</v-btn>
                </v-btn-toggle>
              </v-card>
              <v-card flat>
                <v-pagination color="#2A2F50" v-model="page" :length="usuarios.lastPage" circle></v-pagination>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <!--    CRUD: USUARIOS-->
    <v-dialog v-model="dialogCrudUsuario" max-width="700px">
      <v-card class="pa-3 pt-4">
        <h2 class="ml-1 mb-3">{{ modoEdicao ? 'Editar Usuário' : 'Incluir Usuário' }}</h2>
        <v-form autocomplete="off" ref="form">
          <v-row no-gutters>
            <v-col md="5">
              <v-text-field
                class="mx-1 mb-4"
                ref="nome"
                v-model="novoUsuario.nome"
                spellcheck="false"
                :rules="[rules.required]"
                placeholder=" "
                hide-details
                label="Nome *"
                outlined
                dense
              />
            </v-col>
            <v-col md="5">
              <v-select
                class="mx-1 mb-4"
                ref="acesso_grupo_id"
                v-model="novoUsuario.acesso_grupo_id"
                :items="acessoGrupos"
                :rules="[rules.required]"
                spellcheck="false"
                item-text="descricao"
                item-value="id"
                label="Grupo de Acesso *"
                placeholder=" "
                hide-details
                height="32px"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col>
              <v-card style="position: absolute; max-height: 93px; max-width: 100px; top: 53px; right: 17px">
                <label for="upload">
                  <v-img v-if="avatarTmp" :src="avatarTmp" class="fs-foto-avatar"/>
                  <v-img v-else :src="require('@/assets/semfoto.png')" class="fs-foto-avatar"/>
                </label>
                <v-file-input
                  id="upload"
                  ref="fileInput"
                  v-model="file"
                  accept="image/png, image/jpeg, image/bmp"
                  style="display: none"
                  @change="mostrarAvatar()"
                />
              </v-card>
            </v-col>
            <v-col md="5">
              <v-select
                class="mx-1 mb-4"
                ref="tipos"
                v-model="tipos"
                :items="pessoasTipo"
                :rules="[rules.requiredArray]"
                spellcheck="false"
                item-text="tipo"
                item-value="tipo_padrao"
                label="Tipo *"
                placeholder=" "
                height="32px"
                hide-details
                multiple
                outlined
                dense
              ></v-select>
            </v-col>
            <v-col md="5">
              <v-select
                class="mx-1"
                v-model="novoUsuario.ativo"
                :items="[{ text: 'Sim', value: 'S' }, { text: 'Não', value: 'N' }]"
                spellcheck="false"
                item-text="text"
                item-value="value"
                hide-details
                label="Ativo"
                placeholder=" "
                height="32px"
                outlined
                dense
              ></v-select>
            </v-col>
            <v-row style="border: 1px solid #CCC; border-radius: 5px" class="pa-2 mx-1" no-gutters>
              <v-col md="12" class="mb-4">
                <span class="ml-1" style="color: gray; font-weight: 300; font-size: 12px">Dados de Acesso</span>
              </v-col>
              <v-col>
                <v-text-field
                  class="mx-1 mb-n3"
                  ref="email"
                  v-model="novoUsuario.email"
                  spellcheck="false"
                  :rules="[rules.required, rules.email]"
                  placeholder=" "
                  label="Email *"
                  outlined
                  dense
                />
              </v-col>
              <v-col v-if="modoEdicao" md="3" class="mr-2">
                <v-btn color="#2A2F50" @click="dialogAlterarSenha = true" class="mt-1 ml-1" style="height: 31px" block dark small>
                  <v-icon class="mr-1" style="font-size: 15px !important">mdi-key</v-icon>
                  Alterar Senha
                </v-btn>
              </v-col>
              <v-col v-if="!modoEdicao" md="4">
                <v-text-field
                  class="mx-1 mb-n3"
                  ref="senha"
                  v-model="novoUsuario.senha"
                  spellcheck="false"
                  :rules="[rules.required]"
                  placeholder=" "
                  type="password"
                  label="Senha *"
                  outlined
                  dense
                />
              </v-col>
              <v-col v-if="!modoEdicao" md="4">
                <v-text-field
                  class="mx-1 mb-n3"
                  ref="auxSenha"
                  v-model="auxSenha"
                  spellcheck="false"
                  :rules="[rules.required]"
                  placeholder=" "
                  type="password"
                  label="Repita a Senha *"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-row>
        </v-form>

        <v-card-actions class="mt-3 mr-n1 mb-n1">
          <v-spacer></v-spacer>
          <v-btn v-if="!modoEdicao" color="#2A2F50" @click="incluirUsuario()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Incluir Usuário
          </v-btn>
          <v-btn v-if="modoEdicao" color="#2A2F50" @click="editarUsuario()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Editar Usuário
          </v-btn>
          <v-btn color="warning" @click="dialogCrudUsuario = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAlterarSenha" width="350px">
      <v-card class="pa-3 pt-4">
        <h3 class="ml-1">Alterar Senha</h3>
        <v-divider class="mt-4 mb-5 mx-1"></v-divider>
        <v-row no-gutters>
          <v-col md="12">
            <v-text-field
              class="mx-1 mb-3"
              ref="senha"
              v-model="novoUsuario.senha"
              spellcheck="false"
              :rules="[rules.required]"
              placeholder=" "
              hide-details
              type="password"
              label="Senha *"
              outlined
              dense
            />
          </v-col>
          <v-col md="12">
            <v-text-field
              class="mx-1"
              ref="auxSenha"
              v-model="auxSenha"
              spellcheck="false"
              :rules="[rules.required]"
              placeholder=" "
              type="password"
              label="Repita a Senha *"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-card-actions class="mr-n2 mb-n2">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="alterarSenhaUsuario" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-key</v-icon>
            Alterar Senha
          </v-btn>
          <v-btn color="warning" @click="dialogAlterarSenha = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line
import { listarComFiltros, uploadAvatar, editar } from '@/api/usuario'
import { list, add, edit } from '@/api/crud'
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  components: {
  },
  data () {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        // { text: '' },
        { text: 'Nome', value: 'nome' },
        { text: 'Email', value: 'email' },
        { text: 'Grupo', value: 'acessoGrupo.descricao' },
        { text: 'Ativo', value: 'ativo' },
        { text: 'Data de inclusão', value: 'created_at' },
        { text: 'Ações' }
      ],
      opcoesFiltro: [
        { value: 'S', text: 'Usuários Ativos' },
        { value: 'N', text: 'Usuários Inativos' },
        { value: '', text: 'Todos' }
      ],
      rules: {
        required: value => !!value || 'Campo obrigatório!',
        requiredArray: value => !!value.length || 'Campo obrigatório!',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido!'
        }
      },
      file: null,
      avatarTmp: null,
      dialogCrudUsuario: false,
      dialogAlterarSenha: false,
      modoEdicao: false,
      filtroUsuarios: 'S',
      usuarios: [],
      acessoGrupos: [],
      pessoasTipo: [],
      tipos: [],
      novoUsuario: {},
      novaPessoa: {},
      auxSenha: '',
      formHasErrors: false,
      loading: true,
      sortDesc: false,
      limit: 15,
      page: 1
    }
  },
  filters: {
    zeroEsq: function (value) {
      return value.padStart(7, '0')
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    }),
    form () {
      return {
        nome: this.novoUsuario.nome,
        acesso_grupo_id: this.novoUsuario.acesso_grupo_id,
        tipos: this.tipos,
        email: this.novoUsuario.email,
        senha: this.novoUsuario.senha,
        auxSenha: this.auxSenha
      }
    }
  },
  watch: {
    page: function () {
      this.carregarUsuarios()
    },
    limit: function () {
      this.page = 1
      this.carregarUsuarios()
    },
    filtroUsuarios: function () {
      this.page = 1
      this.carregarUsuarios()
    },
    dialogCrudUsuario: function () { // Limpa o form sempre que o dialog for fechado
      if (!this.dialogCrudUsuario) {
        this.formHasErrors = false
        Object.keys(this.form).forEach(f => {
          if (this.$refs[f]) this.$refs[f].reset()
        })
        this.avatarTmp = null
      }
    }
  },
  mounted () {
    this.carregarUsuarios()
    this.carregarGrupos()
    this.carregarPessoasTipos()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    ...mapActions('global', ['mostrarMsg']),
    formatarDataHora (data, format) {
      return moment(data).format(format)
    },
    abrirDialogIncluirUsuario () {
      this.novoUsuario = {}
      this.novaPessoa = {}
      this.dialogCrudUsuario = true
      this.modoEdicao = false
      this.novoUsuario.ativo = 'S'
    },
    async abrirDialogEditarUsuario (item) {
      const usuario = Object.assign({}, item)
      this.modoEdicao = true
      this.novoUsuario = usuario
      if (usuario.pessoa) {
        this.tipos = usuario.pessoa.tipos.map(x => {
          return `0${x.pessoa_tipo_id}`
        })
        this.avatarTmp = usuario.pessoa.foto_url
        this.novaPessoa.id = usuario.pessoa.id
      }
      this.dialogCrudUsuario = true
    },
    async carregarGrupos () {
      const res = await list('/admin/acessogrupos')
      this.acessoGrupos = res.data.filter(item => {
        return item.ativo === 'S'
      })
    },
    async carregarPessoasTipos () {
      const res = await list('/admin/pessoastipos')
      this.pessoasTipo = res.data
    },
    async carregarUsuarios () {
      this.loading = true
      const filtroComposto = [
        { field: 'ativo', value: this.filtroUsuarios }
      ]
      this.usuarios = await listarComFiltros(filtroComposto, { page: this.page, limit: this.limit })
      this.loading = false
    },
    async incluirUsuario () {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.$refs[f].validate(true)) this.formHasErrors = true
      })
      if (!this.formHasErrors) {
        if (this.auxSenha !== this.novoUsuario.senha) {
          this.mostrarMsg({ msg: 'As senhas informadas não conferem!', color: 'red', timeout: 4000 })
        } else {
          try {
            const res = await add('/admin/usuarioscrm', 'incluir', { usuario: this.novoUsuario, pessoa: this.novaPessoa, tipos: this.tipos })
            this.fazerUploadAvatar(res.usuario_id)
            this.dialogCrudUsuario = false
            this.carregarUsuarios()
            this.mostrarMsg({ msg: 'Usuário incluído com sucesso!', color: 'green', timeout: 4000 })
          } catch (e) {
            this.mostrarMsg({ msg: e, color: 'red', timeout: 10000 })
          }
        }
      }
    },
    async editarUsuario () {
      delete this.novoUsuario.token
      delete this.novoUsuario.senha
      delete this.novoUsuario.token_created_at
      delete this.novoUsuario.created_at
      delete this.novoUsuario.updated_at
      delete this.novoUsuario.pessoa
      delete this.novoUsuario.acessoGrupo
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (this.$refs[f]) {
          if (!this.$refs[f].validate(true)) this.formHasErrors = true
        }
      })
      if (!this.formHasErrors) {
        try {
          await edit('/admin/usuarioscrm', 'editar', this.novoUsuario.id, { usuario: this.novoUsuario, pessoa: this.novaPessoa, tipos: this.tipos })
          await this.fazerUploadAvatar(this.novoUsuario.id)
          this.carregarUsuarios()
          this.dialogCrudUsuario = false
          this.mostrarMsg({ msg: 'Usuário editado com sucesso!', color: 'green', timeout: 4000 })
        } catch (e) {
          this.mostrarMsg({ msg: e, color: 'red', timeout: 10000 })
        }
      }
    },
    async alterarSenhaUsuario () {
      if (this.novoUsuario.senha === this.auxSenha) {
        await editar(this.novoUsuario.id, { senha: this.novoUsuario.senha })
        this.dialogAlterarSenha = false
        this.mostrarMsg({ msg: 'Senha alterada com sucesso!', color: 'green', timeout: 4000 })
      } else {
        this.mostrarMsg({ msg: 'As senhas informadas não conferem!', color: 'red', timeout: 4000 })
      }
    },
    async mostrarAvatar () {
      if (this.file) this.avatarTmp = URL.createObjectURL(this.file)
    },
    async fazerUploadAvatar (usuarioId) {
      if (this.file) {
        const fileFormData = new FormData()
        fileFormData.append('filename', this.file)
        try {
          await uploadAvatar(fileFormData, usuarioId)
        } catch (e) {
          this.mostrarMsg({ msg: 'Ocorreu um erro ao fazer upload do avatar!', color: 'red', timeout: 4000 })
        }
      }
    }
  }
}
</script>

<style>
  #fs-row {
    border-bottom: 1px solid rgba(0,0,0,.12);
  }
  th, td {
    padding-left: 15px !important;
    padding-right: 10px !important;
  }
  th {
    height: 35px !important;
    font-size: 11px !important;
  }
  td {
    font-size: 11.5px !important;
    color: rgb(82, 82, 82);
    height: 37px !important;
  }
  .fs-btn-limit {
    font-size: 11px !important;
  }
  .fs-foto-avatar {
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    height: 93px;
    width: 100px;
    cursor: pointer;
  }
  .fs-foto-avatar:hover {
    transition: .2s;
    opacity: 0.7;
  }
  .fs-miniatura {
    border: 1px solid rgba(214, 214, 214, 0.5);
    width: 50px !important;
    height: 50px !important;
    border-radius: 50px;
    margin: 4px 0px 4px 4px !important;
  }
  .fs-miniatura:hover {
    border: 1px solid rgba(156, 156, 156, 0.527);
    cursor: pointer;
  }
</style>
